import { render, staticRenderFns } from "./_base-order-search.vue?vue&type=template&id=88a01140&scoped=true"
import script from "./_base-order-search.vue?vue&type=script&lang=js"
export * from "./_base-order-search.vue?vue&type=script&lang=js"
import style0 from "./_base-order-search.vue?vue&type=style&index=0&id=88a01140&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a01140",
  null
  
)

export default component.exports